import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Ico from './iconBox';

// import aboutBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class About extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
            {/* End Main Top */}
            {/* Start Top Search */}
            
            {/* End Top Search */}
            {/* Start All Title Box */}
            
            {/* End All Title Box */}
            {/* Start About Page  */}





            <div className="page-header text-center" style={{backgroundImage: 'url("assets/images/page-header-bg.jpg")'}}>
            <div className="container">
              <h1 className="page-title">ABOUT US</h1>
            </div>{/* End .container */}
          </div>{/* End .page-header */}
          <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
            <div className="container">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a >Home</a></li>
                <li className="breadcrumb-item"><a >About Us</a></li>
              </ol>
            </div>{/* End .container */}
          </nav>{/* End .breadcrumb-nav */}



        

<div className='container' style={{margin : "30px 10px"}}>
            <div className='row'  >
            <div className="col-lg-10 col-sm-12" style={{margin  :"auto"}}>


         
            <h1 style={{fontSize:"35px"}}>Premier Destination for Fashion Designer & Bridal Dress Style in Pakistan</h1>

<p>At <strong>Malookcouture.com</strong>, we are dedicated to bringing the latest trends and timeless elegance to your wardrobe. With a diverse selection of <strong>designer clothing</strong> and <strong>accessories</strong>, we aim to help you express your unique style and personality. With over <strong>10 years of experience</strong> in the fashion industry, our passionate team is committed to providing you with high-quality products and exceptional service. Whether you’re looking for <strong>luxury formal wear</strong> or trendy casual outfits, we’re here to enhance your fashion experience. Explore our range and let your style shine with <strong>Malookcouture.com</strong>.</p>

<h3>Our Mission:</h3>
<p>At <strong>Malookcouture.com</strong>, our mission is to empower individuals to embrace their personal style through high-quality fashion. We strive to inspire our customers to express themselves confidently with our diverse selection of clothing and accessories.</p>

<h3>Expertise and Experience:</h3>
<p>With over <strong>10 years of experience</strong> in the fashion industry, <strong>Malookcouture.com</strong> boasts a team of dedicated fashion experts who are passionate about style and quality. Our team’s extensive knowledge ensures that you receive personalized guidance and support to find the perfect pieces for your wardrobe.</p>

<h3>Product Categories:</h3>
<ul>
    <li><strong>Luxury Formal Wear:</strong> Elevate your special occasions with our exquisite collection of formal wear, designed to make you stand out with elegance and sophistication.</li>
    <li><strong>Casual Wear:</strong> Discover our trendy casual wear that combines comfort and style, perfect for everyday outings or relaxed gatherings.</li>
    <li><strong>Pret Wear:</strong> Our ready-to-wear collection offers a variety of stylish outfits that are perfect for any occasion, ensuring you look effortlessly chic.</li>
    <li><strong>Accessories:</strong> Complete your look with our curated selection of accessories, including bags, jewelry, and more, designed to add the perfect finishing touch to your outfit.</li>
</ul>

<h3>Transform Your Wardrobe:</h3>
<p>Whether you’re a fashion enthusiast or just starting to explore your style, <strong>Malookcouture.com</strong> is here to help you transform your wardrobe into a reflection of your personality. Explore our range today and let your fashion journey begin with <strong>Malookcouture.com</strong>.</p>
          
          
          
            </div>
            </div>
            </div>


            <div className="container icon-boxes-section">
                <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2">

                  <div>
                 
                 < Ico/>
                

                  </div>

                </div>
                </div>



            {/* </div> */}
        
          </div>
        )
    }
}

export default About;